module.exports = "https://static.wagwalking.com/_next/static/images/Avatar-2-bee2e2223e09e9cf2869abfc6046ed92.svg";